import { ZONES, works } from "./data";

// URL <-> state mapping. Shape: #/works or #/works/spinenotes
export function parseHash(hash) {
  const clean = String(hash || "").replace(/^#\/?/, "");
  const [zoneId, slug] = clean.split("/");
  const zone = ZONES.findIndex((z) => z.id === zoneId);
  if (zone < 0) return { zone: 0, work: null };
  const work = zoneId === "works" && works.some((w) => w.slug === slug) ? slug : null;
  return { zone, work };
}

export function buildHash(zoneIndex, workSlug) {
  const id = ZONES[zoneIndex].id;
  if (zoneIndex === 0) return "";
  return `#/${id}${workSlug ? `/${workSlug}` : ""}`;
}
